import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    title: {
        defaultMessage: 'APIImport',
        id: 'iaso.label.apiimport',
    },
    search: {
        defaultMessage: 'Search',
        id: 'iaso.search',
    },
    created_at: {
        defaultMessage: 'Created',
        id: 'iaso.forms.created_at',
    },
    user: {
        defaultMessage: 'User',
        id: 'iaso.label.user',
    },
    is_successful: {
        defaultMessage: 'Is successful',
        id: 'iaso.label.is_successful',
    },
    json_body: {
        defaultMessage: 'JSON',
        id: 'iaso.apiimport.json_body',
    },
    exception: {
        defaultMessage: 'Exception',
        id: 'iaso.apiimport.exception',
    },
    headers: {
        defaultMessage: 'Headers',
        id: 'iaso.apiimport.headers',
    },
    import_type: {
        defaultMessage: 'Import Type',
        id: 'iaso.apiimport.import_type',
    },
    has_problem: {
        defaultMessage: 'Has problem?',
        id: 'iaso.apiimport.has_problem',
    },
    app_id: {
        defaultMessage: 'App Id',
        id: 'iaso.projects.appId',
    },
    app_version: {
        defaultMessage: 'App Version',
        id: 'iaso.projects.appVersion',
    },
    import_type_bulk: {
        defaultMessage: 'Bulk Org Units and Instances',
        id: 'iaso.apiimport.import_type_bulk',
    },
    import_type_instance: {
        defaultMessage: 'Form instance',
        id: 'iaso.apiimport.import_type_instance',
    },
    import_type_org_unit: {
        defaultMessage: 'Org Unit',
        id: 'iaso.apiimport.import_type_org_unit',
    },
    import_type_storage_logs: {
        defaultMessage: 'Storage Logs',
        id: 'iaso.apiimport.import_type_storage_logs',
    },
    yes: {
        defaultMessage: 'Yes',
        id: 'iaso.forms.yes',
    },
    no: {
        defaultMessage: 'No',
        id: 'iaso.forms.no',
    },
});

export default MESSAGES;
